import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { provideNgxMask } from 'ngx-mask';
import { MaterialModule } from 'src/app/core/material/material.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { NewCommerceComponent } from './new-commerce.component';
import { SearchPlaceComponentModule } from '../my-commerce/components/search-place/search-place.module';

@NgModule({
  declarations: [NewCommerceComponent],
  exports: [NewCommerceComponent],
  imports: [
    RouterModule.forChild([
      {
        path: '',
        component: NewCommerceComponent
      }
    ]),
    MaterialModule,
    SharedModule,
    CommonModule,
    TranslateModule.forChild({
      isolate: false
    }),
    FormsModule,
    ReactiveFormsModule,
    SearchPlaceComponentModule
  ],
  providers: [provideNgxMask()]
})
export class NewCommerceModule {}
